import React, { createContext, useContext, useMemo } from "react";
import { useClient } from "../hooks/ClientProvider";
import { useHeartbeat } from "../hooks/useHeartbeat";

const { HEARTBEAT_INTERVAL } = process.env;

const HeartbeatContext = createContext({});

export const HeartbeatProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { client } = useClient();

  const ticketInfo = useMemo(
    () => ({
      id: client?.client?.ticket?.id,
      status: client?.client?.ticket?.status,
    }),
    [client]
  );

  useHeartbeat(ticketInfo.id, ticketInfo.status, Number(HEARTBEAT_INTERVAL));
  const contextValue = useMemo(() => ({}), []);

  return (
    <HeartbeatContext.Provider value={contextValue}>
      {children}
    </HeartbeatContext.Provider>
  );
};

export const useHeartbeatContext = () => useContext(HeartbeatContext);
